import { render, staticRenderFns } from "./accountantWork.vue?vue&type=template&id=207f1b52&scoped=true"
import script from "./accountantWork.vue?vue&type=script&lang=js"
export * from "./accountantWork.vue?vue&type=script&lang=js"
import style0 from "./accountantWork.vue?vue&type=style&index=0&id=207f1b52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207f1b52",
  null
  
)

export default component.exports